import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

/**
 * Bloc de contenu repliable — affiche les premiers `previewChars` caractères
 * puis un bouton « Voir plus / Voir moins ». Utilisé pour les longues
 * présentations dont le texte est chargé depuis le CMS et modifiable via le
 * tableau de bord.
 */
export default function Collapsible({
  text = "",
  previewChars = 320,
  className = "",
  testid = "collapsible",
}) {
  const [open, setOpen] = useState(false);
  const clean = (text || "").trim();
  const needsToggle = clean.length > previewChars;
  const preview = needsToggle ? clean.slice(0, previewChars).trimEnd() + "…" : clean;
  const shown = open ? clean : preview;

  return (
    <div className={className} data-testid={testid}>
      <p className="text-lg text-slate-700 leading-relaxed whitespace-pre-line">
        {shown}
      </p>
      {needsToggle && (
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-unisic-blue hover:text-unisic-gold transition-colors"
          data-testid={`${testid}-toggle`}
          aria-expanded={open}
        >
          {open ? (
            <>
              Voir moins <ChevronUp className="w-4 h-4" />
            </>
          ) : (
            <>
              Voir plus <ChevronDown className="w-4 h-4" />
            </>
          )}
        </button>
      )}
    </div>
  );
}
